import { WidgetRegistry } from "@Widgets/types";
import { ConfirmationEmailTop } from "../Components/ConfirmationEmailTop/ConfirmationEmailTop";

const confirmationEmailTopWidgetRegistry: Pick<
  WidgetRegistry,
  "User.ConfirmationEmailTop"
> = {
  "User.ConfirmationEmailTop": {
    Component: ConfirmationEmailTop,
  },
};

export default confirmationEmailTopWidgetRegistry;
